import { initGtmBootstrap } from './gtm-bootstrap';
import { initResetLoader } from './reset-loader';

export function initStartupScripts() {
  initResetLoader();
  initGtmBootstrap();
}
